import React from 'react';

// Main Section Component - Logo slider removed
const SoleraTypesSection = () => {
  return (
    <section
      style={{
        backgroundImage: 'linear-gradient(to bottom, black, rgba(53, 50, 48, 0.50))',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Logo slider removed */}
    </section>
  );
};

export default SoleraTypesSection;
